module.exports = __webpack_public_path__ + "static/media/MaxiNutrition_Proteincoach-Step-5-Wasser-img.1bd93b3b.png";